/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div class="unsubscribe-container">
    <div class="row">
      <div class="get-started-left-col col-sm-5">
        <h1>Manage VoiceVibes Email Alerts</h1>
        <p>
          VoiceVibes allows you to customize which events in your account will trigger
          an email alert and which events will not.
          <br><br>
          To receive
          some emails from VoiceVibes while unsubscribing from others:<br><br>
          <router-link
            :to="{ name: 'manage', query: {tab: 'email'}}"
            class="btn btn-primary"
          >
            Access Email Notifications in Your Account
          </router-link>
        </p>
        <br>
        <h2>Disable All VoiceVibes Email Alerts</h2>
        To remove yourself from all VoiceVibes email notifications:<br><br>
        <button
          class="btn btn-primary"
          @click.prevent="unsubscribe"
        >
          Disable ALL Email Notifications in my Account
        </button>
        <br><br>
      </div>
      <div class="col-sm-6" />
    </div>
    <div class="row">
      <div class="col-sm-5">
        <h2>Unsubscribe from VoiceVibes Marketing Emails</h2>
        Please note that marketing emails sent by VoiceVibes are managed by a separate system. If you
        wish to also unsubscribe from our marketing emails, please locate one of these emails in your inbox
        and click the <strong>Unsubscribe</strong> link at the bottom of the email.
      </div>
      <div class="col-sm-6" />
    </div>
  </div>
</template>

<style lang="less">
  .get-started-left-col {
    background-color: white;
  }
  .unsubscribe-container {
    position: relative;
    background:
        url(https://voicevibes.s3.amazonaws.com/static/images/waves_divider_full_color.svg) 0px 200px no-repeat,
        url(https://voicevibes.s3.amazonaws.com/static/images/Bigtincan_art.jpg) 0px 130px no-repeat;
    background-size: 100%;
  }
</style>

<script>
import Unsubscribe from '../../services/unsubscribe';

export default {
  data() {
    return {};
  },
  methods: {
    unsubscribe() {
      const badCode = () => {
        this.$store.dispatch('notify', {
          type: 'error',
          subject: 'Unable to Unsubscribe',
          text: 'Please try unsubscribing from within your account via the first button on this page.'
        });
      };
      const goodCode = () => {
        this.$store.dispatch('notify', {
          type: 'success',
          subject: 'You\'re Unsubscribed!',
          text: 'You have been unsubscribed from all VoiceVibes email notifications'
        });
      };

      const unsubscribeCode = this.$router.currentRoute.params.unsubscribeCode;
      if (!unsubscribeCode) {
        return badCode();
      }

      Unsubscribe.post({unsubscribeCode})
        .then(() => goodCode())
        .catch(() => badCode());
    }
  },
};
</script>
